import { 
  SimpleGrid, 
  Card, 
  CardHeader, 
  CardBody, 
  Heading, 
  VStack, 
  Box, 
  Text,
  List,
  ListItem,
  ListIcon
} from '@chakra-ui/react';
import { MdFormatQuote } from 'react-icons/md';
import ReactMarkdown from 'react-markdown';

interface Prediction {
  prediction: string;
  predictor: string;
  tone: string;
}

interface MacroPerspective {
  topic: string;
  perspective: string;
}

interface AdditionalInsightsProps {
  predictions?: Prediction[];
  breakdown?: string;
  macro?: MacroPerspective[];
  memorableQuotes?: string[];
  contrarianViews?: string[];
}

export const AdditionalInsights = ({
  predictions = [],
  breakdown = '',
  macro = [],
  memorableQuotes = [],
  contrarianViews = [],
}: AdditionalInsightsProps) => {
  const safeContrarian = contrarianViews || [];
  const safeQuotes = memorableQuotes || [];
  const safeMacro = macro || [];
  const safePredictions = predictions || [];

  const hasContent = safeContrarian.length > 0 || 
                    safeMacro.length > 0 || 
                    safeQuotes.length > 0 || 
                    !!breakdown || 
                    safePredictions.length > 0;

  if (!hasContent) return null;

  return (
    <VStack spacing={6} align="stretch">
      {breakdown && (
        <Card>
          <CardHeader>
            <Heading size="md">Episode Breakdown</Heading>
          </CardHeader>
          <CardBody>
            <Box className="markdown-content">
              <ReactMarkdown>{breakdown}</ReactMarkdown>
            </Box>
          </CardBody>
        </Card>
      )}
      
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        {/* {safeContrarian.length > 0 && (
          <Card gridColumn={{ base: 'span 1', md: 'span 2' }}>
            <CardHeader>
              <Heading size="md">Contrarian Views</Heading>
            </CardHeader>
            <CardBody>
              <List spacing={3}>
                {safeContrarian.map((view, index) => (
                  <ListItem key={index} display="flex" alignItems="flex-start">
                    <ListIcon as={MdTrendingUp} color="purple.500" mt={1} />
                    <Text>{view}</Text>
                  </ListItem>
                ))}
              </List>
            </CardBody>
          </Card> */}
        {/* )} */}
        
        {safeMacro.length > 0 && (
          <Card>
            <CardHeader>
              <Heading size="md">Macro Insights</Heading>
            </CardHeader>
            <CardBody>
              <List spacing={3}>
                {safeMacro.map((item, index) => (
                  <ListItem key={index}>
                    <Text fontWeight="bold" mb={1}>{item.topic}</Text>
                    <Text>{item.perspective}</Text>
                  </ListItem>
                ))}
              </List>
            </CardBody>
          </Card>
        )}
        
        {safeQuotes.length > 0 && (
          <Card gridColumn={{ base: 'span 1', md: 'span 2' }}>
            <CardHeader>
              <Heading size="md">Memorable Quotes</Heading>
            </CardHeader>
            <CardBody>
              <List spacing={3}>
                {safeQuotes.map((quote, index) => (
                  <ListItem key={index} display="flex" alignItems="flex-start">
                    <ListIcon as={MdFormatQuote} color="gray.500" mt={1} />
                    <Text fontStyle="italic">"{quote}"</Text>
                  </ListItem>
                ))}
              </List>
            </CardBody>
          </Card>
        )}
        
        {/* {safePredictions.length > 0 && (
          <Card>
            <CardHeader>
              <Heading size="md">Predictions</Heading>
            </CardHeader>
            <CardBody>
              <List spacing={3}>
                {safePredictions.map((pred, index) => (
                  <ListItem key={index} display="flex" flexDirection="column">
                    <Box display="flex" alignItems="flex-start">
                      <ListIcon as={MdTrendingUp} color="blue.500" mt={1} />
                      <Text>{pred.prediction}</Text>
                    </Box>
                    <Text ml={6} fontSize="sm" color="gray.500">By: {pred.predictor}</Text>
                    <Text ml={6} fontSize="sm" color="gray.500">Tone: {pred.tone}</Text>
                  </ListItem>
                ))}
              </List>
            </CardBody>
          </Card>
        )} */}
      </SimpleGrid>
    </VStack>
  );
}; 